import {
  getBuyerContact,
  getBuyerContactAgent,
  getBuyerContactSolicitor,
  getContactDetails,
  getVendorContact,
  getVendorContactAgent,
  getVendorContactSolicitor,
} from 'api/apiService';
import EnhancedTable from 'component/ContactTab/Table';
import { LoaderContext } from 'component/Loader/LoaderContextProvider';
import { useContext, useEffect, useState } from 'react';
import Loading from 'assets/images/loading.png';
import { Grid, Box, Typography } from '@mui/material';
import { contactErrorContext } from './ContactTab';
import { getusertagDetails } from 'api/apiService';

const headCells = [
  {
    id: 'name',
    numeric: false,
    disablePadding: true,
    label: 'Name',
  },

  {
    id: 'Category',
    numeric: true,
    disablePadding: false,
    label: 'Role',
  },
  {
    id: 'contact',
    numeric: true,
    disablePadding: false,
    label: 'Contact',
  },
  {
    id: 'tag',
    numeric: true,
    disablePadding: false,
    label: 'Tags',
  },

  {
    id: 'action',
    numeric: true,
    disablePadding: false,
    label: 'Action Required',
  },
];

const ContactTabItem = ({
  userType,
  user,
  setSelectedRows,
  onDataLoad,
  selectedRows,
  searchText,
}) => {
  const [properties, setProperties] = useState([]);
  const { setIsLoadingPage } = useContext(LoaderContext);
  const [loader, setLoader] = useState(true);
  const { contextErrorMessage, setContextErrorMessage } =
    useContext(contactErrorContext);

  const attachTagsToContacts = async (resp) => {
    const contacts = Array.isArray(resp?.data)
      ? resp.data
      : Array.isArray(resp?.userDetails)
      ? resp.userDetails
      : [];

    if (!contacts.length) {
      return resp;
    }

    const contactsWithTags = await Promise.all(
      contacts?.map(async (contact) => {
        const tagRes = await getusertagDetails(contact?.user?.userId);
        return {
          ...contact,
          tagDetails: tagRes?.tagDetails || [],
        };
      })
    );

    return {
      ...resp,
      data: Array.isArray(resp?.data) ? contactsWithTags : resp?.data,
      userDetails: Array.isArray(resp?.userDetails)
        ? contactsWithTags
        : resp?.userDetails,
    };
  };
  useEffect(() => {
    const apiFunction = async () => {
      var mounted = true;
      if (userType == 'Buyer' && user == 'AgentAll') {
        await getBuyerContact(userType).then(async (resp) => {
          const updatedResp = await attachTagsToContacts(resp);

          setProperties({
            ...updatedResp,
            userDetails: Array.isArray(updatedResp?.userDetails)
              ? updatedResp.userDetails
              : Array.isArray(updatedResp?.data)
              ? updatedResp.data
              : [],
          });
        });
      } else if (userType == 'Vendor' && user == 'AgentAll') {
        await getVendorContact(userType).then(async (resp) => {
          const updatedResp = await attachTagsToContacts(resp);

          setProperties({
            ...updatedResp,
            userDetails: Array.isArray(updatedResp?.userDetails)
              ? updatedResp.userDetails
              : Array.isArray(updatedResp?.data)
              ? updatedResp.data
              : [],
          });
        });
      } else if (user == 'buyerAgent') {
        await getBuyerContactAgent().then(async (resp) => {
          const updatedResp = await attachTagsToContacts(resp);

          setProperties({
            ...updatedResp,
            userDetails: Array.isArray(updatedResp?.userDetails)
              ? updatedResp.userDetails
              : Array.isArray(updatedResp?.data)
              ? updatedResp.data
              : [],
          });
        });
      } else if (user == 'vendorAgent') {
        await getVendorContactAgent().then(async (resp) => {
          const updatedResp = await attachTagsToContacts(resp);

          setProperties({
            ...updatedResp,
            userDetails: Array.isArray(updatedResp?.userDetails)
              ? updatedResp.userDetails
              : Array.isArray(updatedResp?.data)
              ? updatedResp.data
              : [],
          });
        });
      } else if (user == 'buyerSolicitor') {
        await getBuyerContactSolicitor().then(async (resp) => {
          const updatedResp = await attachTagsToContacts(resp);

          setProperties({
            ...updatedResp,
            userDetails: Array.isArray(updatedResp?.userDetails)
              ? updatedResp.userDetails
              : Array.isArray(updatedResp?.data)
              ? updatedResp.data
              : [],
          });
        });
      } else if (user == 'vendorSolicitor') {
        await getVendorContactSolicitor().then(async (resp) => {
          const updatedResp = await attachTagsToContacts(resp);

          setProperties({
            ...updatedResp,
            userDetails: Array.isArray(updatedResp?.userDetails)
              ? updatedResp.userDetails
              : Array.isArray(updatedResp?.data)
              ? updatedResp.data
              : [],
          });
        });
      } else {
        await getContactDetails().then(async (resp) => {
          const updatedResp = await attachTagsToContacts(resp);

          if (mounted) {
            setProperties({
              ...updatedResp,
              userDetails: Array.isArray(updatedResp?.userDetails)
                ? updatedResp.userDetails
                : Array.isArray(updatedResp?.data)
                ? updatedResp.data
                : [],
            });
          }
        });
      }
      setLoader(false);
      return () => (mounted = false);
    };
    apiFunction();
  }, []);
  useEffect(() => {
    const dataToPass = Array.isArray(properties?.data)
      ? properties.data
      : Array.isArray(properties?.userDetails)
      ? properties.userDetails
      : [];

    if (dataToPass?.length > 0 && onDataLoad) {
      onDataLoad(dataToPass);
    } else {
    }
  }, [properties, onDataLoad]);

  const userDetails = Array.isArray(properties?.userDetails)
    ? properties.userDetails
    : [];

  const filteredUserDetails = userDetails?.filter((item) =>
    `${item?.user?.userName || ''} ${item?.user?.userSurName || ''}`
      .toLowerCase()
      .includes(searchText.toLowerCase())
  );

  const filteredProperties = {
    ...properties,
    userDetails: filteredUserDetails,
  };

  return (
    <>
      {loader ? (
        <Grid
          sx={{
            display: 'flex',
            justifyContent: 'center',
            height: '100%',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <Box>
            <img
              alt="Logo"
              src={Loading}
              className="loaderImage"
              style={{ height: '100px', width: '100px' }}
            />
          </Box>
          <Typography sx={{ fontFamily: 'poppins' }}>Loading...</Typography>
        </Grid>
      ) : searchText.trim() !== '' && filteredUserDetails.length === 0 ? (
        <Typography
          sx={{
            display: 'flex',
            justifyContent: 'center',
            fontSize: '14px',
            fontFamily: 'Poppins',
            padding: '20px',
          }}
        >
          No Search contact available
        </Typography>
      ) : (
        <>
          {/* {properties?.status == 1  ? ( */}
          <Box
            sx={{
              height: properties?.status == 1 ? 'auto' : 0,
              opacity: properties?.status == 1 ? 1 : 0,
            }}
          >
            <EnhancedTable
              headCells={headCells}
              properties={filteredProperties}
              user={user}
              contextErrorMessage={contextErrorMessage}
              setContextErrorMessage={setContextErrorMessage}
              setProperties={setProperties}
              style={{ padding: '0px !important' }}
              setSelectedRows={setSelectedRows}
              selectedRows={selectedRows}
            />
          </Box>
          {/* ) : ( */}
          <Typography
            sx={{
              display: properties?.status != 1 ? 'flex' : 'none',
              justifyContent: 'center',
              fontSize: '14px',
              fontFamily: 'poppins',
              padding: '20px',
            }}
          >
            {contextErrorMessage}
          </Typography>
          {/* )} */}
        </>
      )}
    </>
  );
};
export default ContactTabItem;
